/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuInputRangeDimensions_filters$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenuFilterDimensions_filters$ref: FragmentReference;
export type SbRespRefineMenuFilterDimensions_filters = $ReadOnlyArray<{|
  +$fragmentRefs: SbSharedRefineMenuInputRangeDimensions_filters$ref,
  +$refType: SbRespRefineMenuFilterDimensions_filters$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterDimensions_filters",
  "type": "SearchBrowseFilter",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_filters",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'da120dcca3c094f9a082023bad3bbb40';
module.exports = node;
